import { createFileRoute } from "@tanstack/react-router";
import TmsForEms from "@/pages/TmsForEms";
export const Route = createFileRoute("/tms-for-ems")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "TMS For Ems | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "TMS for EMTs and paramedics facing depression and PTSD. Learn about first responder mental health treatment in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:title",
          content: "TMS For Ems | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "TMS for EMTs and paramedics facing depression and PTSD. Learn about first responder mental health treatment in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/tms-for-ems",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/tms-for-ems",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <TmsForEms />;
}
